import { Slider, styled } from '@mui/material';

export const StyledSlider = styled(Slider)(({ theme }) => ({
  color: '#6174d1',
  height: theme.spacing(1),
  marginTop: theme.spacing(4),
  '& .MuiSlider-track': {
    border: 'none',
  },
  '& .MuiSlider-rail': {
    color: '#f1f5f9',
    opacity: 1,
  },
  '& .MuiSlider-thumb': {
    height: theme.spacing(2.5),
    width: theme.spacing(2.5),
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit',
    },
    '&::before': {
      display: 'none',
    },
  },
  '& .MuiSlider-mark': {
    backgroundColor: '#e0e0e0',
  },
  '& .MuiSlider-markLabel': {
    top: 'initial',
    bottom: theme.spacing(3.75),
  },
}));
